import { render, staticRenderFns } from "./currency-edit.vue?vue&type=template&id=190ee0a5&"
import script from "./currency-edit.vue?vue&type=script&lang=js&"
export * from "./currency-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports